export const TABS_ID = {
  contacts: 'contacts',
  associations: 'associations',
  comments: 'comments',
  playbooks: 'playbooks'
};
export const DEFAULT_TABS = [{
  id: TABS_ID.contacts,
  icon: 'lists',
  dataTestId: 'contacts-tab-button'
}, {
  id: TABS_ID.associations,
  icon: 'objectAssociations',
  dataTestId: 'associations-tab-button'
}, {
  id: TABS_ID.comments,
  icon: 'edit',
  dataTestId: 'comments-tab-button'
}, {
  id: TABS_ID.playbooks,
  icon: 'bulletList',
  dataTestId: 'playbooks-tab-button'
}];
export const ATTENDEE_TABS = DEFAULT_TABS.filter(tab => tab.id !== TABS_ID.contacts);